<template>
  <c-box mb="lg">
    <c-flex v-if="results.searching" width="100%" justify-content="center">
      <Spinner />
    </c-flex>
    <template v-if="!results.searching">
      <c-box v-for="(r, idx) in results.data" v-bind:key="r.path">
        <GlobalSearchResult
          v-if="large || idx < results.smallListLimit"
          :result="r"
          v-chakra
          :borderTop="idx === 0 ? 'none' : '1px solid var(--chakra-colors-gray-200)'"
        ></GlobalSearchResult>
      </c-box>
    </template>
    <c-box :mt="{ base: 0, md: 'lg' }" fontSize="sm" fontWeight="400" ml="lg">
      <router-link
        v-if="!large && results.count > results.requestedCount"
        :to="{ path: '/search' }"
        v-chakra
        textDecoration="underline"
        >{{ $t("globalSearch.viewMore") }}</router-link
      >
      <c-text as="span" v-if="large && results.count > results.requestedCount">{{
        $t("globalSearch.first100Displayed")
      }}</c-text>
    </c-box>
  </c-box>
</template>

<script lang="ts">
import GlobalSearchResult from "@/components/globalSearch/GlobalSearchResult.vue";
import Spinner from "@/components/Spinner.vue";
import { CBox, CFlex, CText } from "@chakra-ui/vue";
import { ISearchResults } from "@iloq/shared";
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "GlobalSearchResultList",
  components: {
    CBox,
    CText,
    CFlex,
    GlobalSearchResult,
    Spinner,
  },
  props: {
    results: {
      type: Object as PropType<ISearchResults>,
      required: true,
    },
    large: {
      type: Boolean,
      default: false,
    },
  },
});
</script>
